import { supabase } from '../contexts/SupabaseAuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const SUPPORT_EMAIL = 'privacy@cura-check.com';

const authHeaders = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {};
};

const errorCode = async (res) => {
  try {
    return (await res.json())?.detail?.code || null;
  } catch (e) {
    return null;
  }
};

/**
 * Elimina l'account del titolare. Esito:
 * deleted | nothing_deleted | incomplete | login_not_removed | unknown (nessuna risposta dal server)
 * Se resta solo il login, lo chiude subito nella stessa sessione.
 */
export const deleteFamilyAccount = async (famigliaId) => {
  let res;
  try {
    res = await fetch(`${API_URL}/api/privacy/delete-account/${famigliaId}?confirm=true`, {
      method: 'DELETE',
      headers: await authHeaders()
    });
  } catch (e) {
    return 'unknown';
  }
  if (res.ok) return 'deleted';
  if (res.status !== 500) return 'nothing_deleted';
  const code = await errorCode(res);
  if (code === 'incomplete') return 'incomplete';
  if (code !== 'login_not_removed') return 'nothing_deleted';

  try {
    const retry = await fetch(`${API_URL}/api/privacy/delete-login?famiglia_id=${encodeURIComponent(famigliaId)}`, {
      method: 'DELETE',
      headers: await authHeaders()
    });
    return retry.ok ? 'deleted' : 'login_not_removed';
  } catch (e) {
    return 'login_not_removed';
  }
};

// Sessione chiusa solo sul dispositivo: il login sul server non esiste più
export const signOutAfterDeletion = async () => {
  try {
    await supabase.auth.signOut({ scope: 'local' });
  } catch (e) {
    // la sessione locale viene comunque abbandonata con il cambio pagina
  }
};
